/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

 var Nav = {
  selectors: {
  },

  init: function() {
    return;
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  },

  /**
   * Automatically called by mp.js when document is ready. Perform any jQuery
   * setup for the extension here (e.g. event listeners, initial state)
   */
  onReady: function(){
  },

  onScrollDown: function() {
    document.getElementById('navbar').classList.remove('scrolled-up');
    document.getElementById('navbar').classList.add('scrolled-down');
  },

  onScrollUp: function() {
    document.getElementById('navbar').classList.remove('scrolled-down');
    document.getElementById('navbar').classList.add('scrolled-up');
  },

  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll");
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll");
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;